import { render, staticRenderFns } from "./KnowledgeManageSettingsRowAction.vue?vue&type=template&id=cf9bfe76&scoped=true&"
import script from "./KnowledgeManageSettingsRowAction.vue?vue&type=script&lang=js&"
export * from "./KnowledgeManageSettingsRowAction.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeManageSettingsRowAction.vue?vue&type=style&index=0&id=cf9bfe76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9bfe76",
  null
  
)

export default component.exports